import Group from 'components/utils/Group'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import BodyText from 'components/Luxkit/Typography/BodyText'
import BestOfBackgroundImage from './BestOfBackgroundImage'
import BestOfSquareLogo from './BestOfSquareLogo'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'components/Luxkit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

const Background = styled(BestOfBackgroundImage)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
`

const Content = styled(Group)`
  transform: translateZ(0);
`

const Banner = styled(Group)`
  padding: ${rem(12)};
  position: relative;

  ${mediaQueryUp.tablet} {
    height: ${rem(154)};
  }

`

function BestOfSearchHeroBanner() {
  return <CSSBreakpoint min="tablet">
    <Banner direction="horizontal" verticalAlign="center" horizontalAlign="center">
      <Background overlayStyle="default"/>
      <Content
        direction="horizontal"
        gap={20}
        verticalAlign="center"
        horizontalAlign="center"
    >
        <BestOfSquareLogo height={79} />
        <VerticalSpacer gap={2}>
          <Heading variant="heading2" colour="neutral-eight">The best escapes are <u>back</u></Heading>
          <BodyText variant="large" format="uppercase" colour="neutral-eight">Limited time only</BodyText>
        </VerticalSpacer>
      </Content>
    </Banner>
  </CSSBreakpoint>
}

export default BestOfSearchHeroBanner
